function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, setup as _setup } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/popover/vue";
import Modal from "@opentiny/vue-modal";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var classes = {
  "title": "text-color-icon-primary font-bold text-xs",
  "popper": "leading-5 hidden sm:block static sm:absolute px-4 py-3 z-[2000] text-justify text-sm sm:text-xs break-all sm:max-w-[21.875rem] shadow-md bg-color-bg-1 rounded [&[x-placement^=top]]:mb-2.5 [&[x-placement^=bottom]]:mt-2.5 [&[x-placement^=right]]:ml-2.5 [&[x-placement^=left]]:mr-2.5",
  "arrow": 'absolute block w-0 h-0 border-[0.375rem] border-transparent border-solid after:absolute after:block after:w-0 after:h-0 after:border-[0.3125rem] after:border-transparent after:border-solid after:content-[""]',
  "placement-top": "-bottom-3 border-t-color-bg-1 drop-shadow-[0_2px_2px_rgba(0,0,0,0.08)] border-b-w-0 after:-bottom-[0.3125rem] after:-ml-[0.3125rem] after:border-t-color-bg-1 after:border-b-w-0",
  "placement-bottom": "-top-3 border-t-w-0 border-b-color-bg-1 drop-shadow-[0_-2px_2px_rgba(0,0,0,0.08)] after:-top-[0.3125rem] after:-ml-[0.3125rem] after:border-t-w-0 after:border-b-color-bg-1",
  "placement-right": "-left-3 border-r-color-bg-1 drop-shadow-[2px_0_2px_rgba(0,0,0,0.08)] border-l-w-0 after:-bottom-[0.3125rem] after:-left-[0.3125rem] after:border-r-color-bg-1 after:border-l-w-0",
  "placement-left": "-right-3 border-l-color-bg-1 drop-shadow-[-2px_0px_2px_rgba(0,0,0,0.08)] border-r-w-0 after:-bottom-[0.375rem] after:-right-[0.3125rem] after:-ml-[0.3125rem] after:border-l-color-bg-1 after:border-r-w-0"
};
var __vue2_script = defineComponent({
  inheritAttrs: false,
  name: $prefix + "Popover",
  components: {
    TinyModal: Modal
  },
  emits: ["update:modelValue", "hide", "show", "after-enter", "after-leave", "created"],
  props: _extends({}, $props, {
    appendToBody: {
      type: Boolean,
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    closeDelay: {
      type: Number,
      default: 200
    },
    content: String,
    disabled: Boolean,
    modelValue: Boolean,
    offset: {
      default: 0
    },
    openDelay: {
      type: Number,
      default: 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    popper: {},
    popperClass: String,
    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },
    reference: {},
    tabindex: {
      type: Number,
      default: 0
    },
    title: String,
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    transition: {
      type: String,
      default: "fade-in-linear"
    },
    trigger: {
      type: String,
      default: "click",
      validator: function validator(value) {
        return ~["click", "focus", "hover", "manual"].indexOf(value);
      }
    },
    visibleArrow: {
      default: true
    },
    genArrowByHtml: {
      type: Boolean,
      default: function _default2() {
        return true;
      }
    },
    width: {}
  }),
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api,
      classes
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", {
    ref: "root",
    class: _vm.$attrs.class
  }, [_c("transition", {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.state.showPopper,
      expression: "!disabled && state.showPopper"
    }],
    ref: "popper",
    class: [_vm.gcls("popper"), _vm.popperClass, {
      "hidden": _vm.disabled || !_vm.state.showPopper
    }],
    style: {
      width: _vm.width + "px"
    },
    attrs: {
      "role": "tooltip",
      "id": _vm.state.tooltipId,
      "aria-hidden": _vm.disabled || !_vm.state.showPopper ? "true" : "false"
    }
  }, [_vm.title ? _c("div", {
    class: [_vm.gcls("title")],
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.content))];
  }), _vm.visibleArrow ? _c("div", {
    class: [_vm.gcls("arrow"), _vm.gcls("placement-" + _vm.state.xPlacement.split("-")[0])],
    attrs: {
      "x-arrow": ""
    }
  }) : _vm._e()], 2)]), _c("span", {
    ref: "wrapper"
  }, [_vm._t("reference")], 2), _c("div", {
    staticClass: "sm:hidden inline-block"
  }, [_c("tiny-modal", {
    ref: "modal",
    staticClass: "sm:hidden",
    attrs: {
      "tiny_mode": "mobile-first",
      "title": _vm.title
    },
    scopedSlots: _vm._u([_vm.slots.default ? {
      key: "default",
      fn: function fn(params) {
        return [_vm._t("default", null, null, params)];
      }
    } : null], null, true),
    model: {
      value: _vm.state.showPopper,
      callback: function callback($$v) {
        _vm.$set(_vm.state, "showPopper", $$v);
      },
      expression: "state.showPopper"
    }
  }, [!_vm.slots.default ? [_vm._v(" " + _vm._s(_vm.content) + " ")] : _vm._e()], 2)], 1)], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
